import React from "react";
import Select from "react-select";
import { Button, NumberLabel, Icon } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faChartBar, faQuestion } from "@fortawesome/free-solid-svg-icons";

import ModelsIconWhite from "images/modelsWhite.svg";

import ModelTileContainer from "containers/Tiles/ModelTile";
import RunPlotContainer from "containers/RunPlot/RunPlot";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";

import { PanelHeader, PanelBody, PanelFooter } from "components/Wizard/RightPanel/RightPanel";

import styles from "./style.module.css";
import { PANEL_MODES } from "containers/Run/reducer";

export default class SelectedModel extends React.PureComponent {
  render() {
    const {
      id,
      panelMode,
      isQuickRun,
      isContinuous,
      netImpactLabel,
      models,
      model,
      continueWithModel,
      conversionGain,
      conversionCost,
      updateChooseModel,
      trueAction,
      scrollToEnd,
      updatePanelMode
    } = this.props;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1,
      justification: "L"
    };

    const currentState =
      models && models.filter((m) => m.id === "Current State").length > 0
        ? models.filter((m) => m.id === "Current State")[0]
        : undefined;

    const impact = model
      ? model.maxIeration && model.maxIteration.displayImpact
        ? Math.round(model.maxIteration.displayImpact)
        : Math.round(model.checkMax)
      : undefined;

    const currentStateImpact =
      currentState === undefined
        ? undefined
        : currentState.maxIteration && currentState.maxIteration.displayImpact
          ? Math.round(currentState.maxIteration.displayImpact)
          : Math.round(currentState.checkMax);

    const processed = model && model.maxIteration ? Math.round((1 - model.maxIteration.processed) * 100) : undefined;

    const processMissed = model && model.maxIteration ? model.maxIteration.processMissed : undefined;

    let modelIndex = undefined;
    let currentStateIndex = undefined;

    models &&
      models.forEach((m, i) => {
        if (m.id === model.id) {
          modelIndex = i;
        }
        if (m.id === "Current State") {
          currentStateIndex = i;
        }
      });

    return (
      <React.Fragment>
        <PanelHeader>
          <img className={styles.modelIcon} src={ModelsIconWhite} />
          <div className={styles.mTitle}>{"Selected Model"}</div>
          <div className={styles.optionHolder}>
            <Select
              options={models.map((m) => ({ value: m.id, label: m.label }))}
              value={model ? { value: model.id, label: model.label } : undefined}
              onChange={(val) => updateChooseModel(val.value)}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 100
                })
              }}
              isSearchable={false}
            />
          </div>
          <div className={styles.optionClose} onClick={() => updatePanelMode(PANEL_MODES.CLOSED)}>
            <Icon size={14} type="times" />
          </div>
        </PanelHeader>
        <PanelBody>
          {!isQuickRun && (
            <div className={styles.infoHolder}>
              <div className={styles.infoR}>
                <div className={styles.infoHeader}>
                  {isContinuous ? "Total Cost" : isQuickRun ? "Failure Count" : netImpactLabel}
                </div>
                <div className={styles.infoNum}>
                  {isContinuous !== true && isQuickRun !== true && impact < 0 && "-"}
                  <NumberLabel isSpan params={numberFormatParams}>
                    {Math.abs(impact)}
                  </NumberLabel>
                </div>
                {currentState && (
                  <div>
                    <NumberLabel params={numberFormatParams}>
                      {impact > currentStateImpact
                        ? Math.abs(impact - currentStateImpact)
                        : Math.abs(currentStateImpact - impact)}
                    </NumberLabel>
                    {impact > currentStateImpact ? " more than current state" : " less than current state"}
                  </div>
                )}
              </div>
              {processed && isQuickRun !== true ? (
                <div className={styles.infoR}>
                  <div className={styles.infoHeader}>{"Resourcing"}</div>
                  <div className={styles.infoNum}>
                    {processMissed < 0 ? Math.round(Math.abs(processMissed * 100)) + "% more" : processed + "%"}
                  </div>
                  <div>{"remaining capacity to " + trueAction}</div>
                </div>
              ) : (
                <div />
              )}
            </div>
          )}
          {/* <ModelTileContainer id={id} model={model} isRightPanel /> */}
          {!isQuickRun && (
            <div className={styles.rightPlotHolder}>
              <RunPlotContainer
                id={id}
                isSmall
                pointerEvents
                disableBts={conversionGain === 1 && conversionCost === -1}
              />
            </div>
          )}
          {model && (
            <div className={styles.rightFeatures + " " + (isQuickRun ? styles.quickRightFeatures : "")}>
              <FeatureChartContainer
                id={id}
                label={"Hover to see more information about each variable"}
                isHideSelect
                predictMode={"drivers"}
                pointerEvents
                hideTitle
                isQuickRun
              />
            </div>
          )}
        </PanelBody>
        {!isQuickRun && (
          <PanelFooter>
            <Button type="secondary" style={{ marginRight: "10px" }} onClick={() => scrollToEnd()}>
              {"Back to Model Selection"}
            </Button>
            <Button type="primary" style={{ marginLeft: "10px" }} onClick={() => continueWithModel()}>
              {"Continue With This Model"}
            </Button>
          </PanelFooter>
        )}
      </React.Fragment>
    );
  }
}
